/** @jsxImportSource @emotion/react */

import React from 'react';
import ReactMarkdown from 'react-markdown';
import { connect } from 'unistore/react';
import { css } from '@emotion/react';
import Countdown from 'react-countdown';
import {
	differenceInMinutes,
	differenceInHours,
	differenceInDays,
} from 'date-fns';

import { Button } from '@components';
import YoutubeBtn from '../../../components/Button/youtubeBtn';
import { If, Then } from '../../../components/IfElse';
// import SmallPulse from '../Loader/smallPulse';

import { Harpic } from '@utils/customLib';
// import { actions } from '@utils/store/actions';

// const colors = new Map([
// 	[
// 		-1,
// 		{
// 			bg: 'bg-redLighter',
// 			text: 'text-redOrangified',
// 			icon: '#e74c3c',
// 		},
// 	],
// 	[
// 		0,
// 		{
// 			bg: 'bg-deepPeach',
// 			text: 'text-dharkyBhicky',
// 			icon: '#F4977C',
// 		},
// 	],
// 	[
// 		1,
// 		{
// 			bg: 'bg-lightSeaGreen',
// 			text: 'text-primary',bb-
// 			icon: '#1abc9c',
// 		},
// 	],
// ]);

const notifCdTimerStyle = css`
	width: 40px;
`;

const imgWrapperStyle = css`
	transform: translateY(calc(-50% + 100px)) scale(0.8);
`;

const AnnounceTimer = ({ completed, days, hours, minutes, seconds }) => (
	<If condition={!completed}>
		<Then>
			<div className="bb-fS__timer__Wrap my-4 text-sm">
				<div className="bb-fS__timer__Item mr-6">
					<div
						className="bb-fS__timer__Numbr font-bold text-xl p-3 mb-2"
						css={notifCdTimerStyle}
					>
						{days}
					</div>
					<div>Days</div>
				</div>
				<div className="bb-fS__timer__Item mr-6">
					<div
						className="bb-fS__timer__Numbr font-bold text-xl p-3 mb-2"
						css={notifCdTimerStyle}
					>
						{hours}
					</div>
					<div>Hours</div>
				</div>
				<div className="bb-fS__timer__Item mr-6">
					<div
						className="bb-fS__timer__Numbr font-bold text-xl p-3 mb-2"
						css={notifCdTimerStyle}
					>
						{minutes}
					</div>
					<div>Minutes</div>
				</div>
				<div className="bb-fS__timer__Item mr-6">
					<div
						className="bb-fS__timer__Numbr font-bold text-xl p-3 mb-2"
						css={notifCdTimerStyle}
					>
						{seconds}
					</div>
					<div>Seconds</div>
				</div>
			</div>
		</Then>
	</If>
);

const ImageItem = ({ alt, link, img, h, close }) => (
	<a href={link} target="_blank" rel="noreferrer noopener" onClick={close}>
		<img
			src={img}
			alt={Harpic(alt)}
			css={css`
				height: ${h}px;
			`}
			className="inline-block mt-2 mr-4"
		/>
	</a>
);

const LinkItem = ({
	type,
	text,
	title,
	web,
	close,
	video,
	color,
	isUnread,
}) => {
	let btnProps = {};
	const sanitizedText = Harpic(text);

	if (color && isUnread) {
		let newColor;
		switch (color) {
			case 1:
				newColor = 'violet';
				break;
			case 2:
				newColor = 'orange';
				break;
			case 3:
				newColor = 'green';
				break;
			case 4:
				newColor = 'violet';
				break;
			default:
				break;
		}

		btnProps = {
			color: newColor,
		};
	} else {
		btnProps = {
			variant: 'minimal',
		};
	}
	switch (type) {
		case 0:
			return (
				<Button
					href={`https://bitbns.com/trade/#${web}`}
					onClick={close}
					{...btnProps}
					triangle="right"
					size="tiny"
					className="mr-4 mb-4"
				>
					{sanitizedText}
				</Button>
			);
		case 2:
			return (
				<YoutubeBtn
					onClick={close}
					{...btnProps}
					triangle="right"
					size="tiny"
					videoId={video}
					modalText={title}
					text={sanitizedText}
					className="mr-4 mb-4"
				/>
			);
		default:
			return (
				<Button
					target="_blank"
					rel="noreferrer noopener nofollow"
					href={web}
					onClick={close}
					{...btnProps}
					triangle="right"
					size="tiny"
					className="mr-4 mb-4"
				>
					{sanitizedText}
				</Button>
			);
	}
};

// const circleStyle = {
// 	height: '3px',
// 	width: '7px',
// 	opacity: '.7',
// 	left: '-10px',
// 	top: '50%',
// 	transform: 'translateY(-50%)',
// };

const NotifRow = React.memo(
	({
		id,
		sideNotifsLastRead,
		title,
		text,
		links,
		close,
		images,
		imgUrl,
		img,
		countDownTimer,
		countDownTimerText,
		endTime,
	}) => {
		const sanitizedTitle = Harpic(title);
		const sanitizedCdTimerText = Harpic(countDownTimerText);
		const date = id * 1000;
		let dateText = '';
		const currDate = Date.now();
		const dateDifference = currDate - date;

		if (dateDifference < 3600000) {
			dateText = `${differenceInMinutes(currDate, date)} mins ago`;
		} else if (dateDifference < 86400000) {
			dateText = `${differenceInHours(currDate, date)} hrs ago`;
		} else if (dateDifference < 2592000000) {
			dateText = `${differenceInDays(currDate, date)} days ago`;
		}
		const isUnread = id > sideNotifsLastRead;

		return (
			<li
				className={`bb-notification__notifLi py-8 px-8 shadow-inner hover:shadow-none ${
					isUnread
						? 'bg-white'
						: 'bg-snowWhite text-lightGray hover:bg-white'
				}`}
				css={css`
					transition: background 0.3s ease-out;
				`}
			>
				<If condition={img}>
					<Then>
						<div
							className="rounded-lg overflow-hidden shadow-lg mb-8"
							css={css`
								max-height: 200px;
								background: linear-gradient(
									to right,
									#362652,
									#4d327b
								);
							`}
						>
							{imgUrl ? (
								<a
									href={imgUrl}
									target="_blank"
									rel="noreferrer noopener nofollow"
									className="flex items-center shadow-2xl"
									css={imgWrapperStyle}
								>
									<img src={img} alt={sanitizedTitle} />
								</a>
							) : (
								<div
									className="flex items-center shadow-2xl"
									css={imgWrapperStyle}
								>
									<img src={img} alt={sanitizedTitle} />
								</div>
							)}
						</div>
					</Then>
				</If>
				<div className="flex items-center justify-between">
					{/* <div
						className={`rounded-full ${
							colors.get(type).bg
						} absolute`}
						style={circleStyle}
					/> */}
					<ReactMarkdown
						components={{
							p: props => (
								<div
									{...props}
									className={`${
										isUnread
											? 'text-primary'
											: 'text-lightGray'
									} font-bold leading-none`}
								/>
							),
						}}
					>
						{sanitizedTitle}
					</ReactMarkdown>
					{/* {date > sideNotifsLastRead && (
						<SmallPulse
							style={pulseStyle}
							className="text-pastelRed mr-4"
						/>
					)} */}

					<div className="text-xs text-lightGray">{dateText}</div>
				</div>
				<ReactMarkdown
					components={{
						p: props => (
							<p {...props} className="leading-normal my-4" />
						),
					}}
				>
					{text}
				</ReactMarkdown>
				{countDownTimer === 1 && endTime && (
					<div className="mt-4">
						<b>{sanitizedCdTimerText}</b>
						<Countdown
							key={endTime}
							date={endTime * 1000}
							renderer={AnnounceTimer}
						/>
					</div>
				)}
				{images &&
					images.map(image => (
						<ImageItem {...image} key={image.img} close={close} />
					))}
				{typeof links !== 'undefined' && links.length > 0 && (
					<div className="mt-4">
						{links.map(link => (
							<LinkItem
								isUnread={isUnread}
								key={link.web}
								{...link}
								close={close}
								title={sanitizedTitle}
							/>
						))}
					</div>
				)}
			</li>
		);
	}
);

export default connect('sideNotifsLastRead')(NotifRow);
